import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DateFilter } from '../types/filterTypes';
import { RootState } from './store';


interface FilterState {
  dateFilter: DateFilter;
  selectedUserId: string | null;
  userIds: string[];
  selectedTeamFilter: 'all' | 'managed' | 'individual';
}

const initialState: FilterState = {
  dateFilter: {
    type: 'today',
    startDate: new Date(new Date().setHours(0, 0, 0, 0)),
    endDate: new Date()
  },
  selectedUserId: null,
  userIds: [],
  selectedTeamFilter: 'all'
};

const selectCurrentFilters = (state: RootState) => ({
  dateFilter: state.filter.dateFilter,
  selectedUserId: state.filter.selectedUserId,
  userIds: state.filter.userIds,
  selectedTeamFilter: state.filter.selectedTeamFilter
});

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setDateFilter: (state, action: PayloadAction<DateFilter>) => {
      state.dateFilter = action.payload;
    },
    setSelectedUser: (state, action: PayloadAction<string | null>) => {
      state.selectedUserId = action.payload;
    },
    setUserIds: (state, action: PayloadAction<string[]>) => {
      state.userIds = action.payload;
    },
    setTeamFilter: (state, action: PayloadAction<'all' | 'managed' | 'individual'>) => {
      state.selectedTeamFilter = action.payload;
      if (action.payload === 'all') {
        state.selectedUserId = null;
        state.userIds = [];
      }
    }
  }
});

export const { setDateFilter, setSelectedUser, setUserIds, setTeamFilter } = filterSlice.actions;

export default filterSlice.reducer;